export default __webpack_public_path__ + "img/InterDisplay-BlackItalic_4637eb2.woff2";